var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 20.3395C4 16.5255 4 14.6185 4.86533 13.0376C5.73067 11.4567 7.31158 10.4755 10.4734 8.51322L13.8067 6.44446C17.149 4.37016 18.8201 3.33301 20.6667 3.33301C22.5132 3.33301 24.1844 4.37016 27.5266 6.44446L30.8599 8.51322C34.0218 10.4755 35.6027 11.4567 36.468 13.0376C37.3333 14.6185 37.3333 16.5255 37.3333 20.3395V22.8746C37.3333 29.3761 37.3333 32.6268 35.3807 34.6466C33.4281 36.6663 30.2854 36.6663 24 36.6663H17.3333C11.0479 36.6663 7.90524 36.6663 5.95262 34.6466C4 32.6268 4 29.3761 4 22.8746V20.3395Z",
    stroke: "#2D334E",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/Home.7fcefbbefca11165ddb4a137f3c057ad.svg";
export { ForwardRef as ReactComponent };